/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseValidator} from "./BaseValidator";

export class LessThanOtherNumericValidator extends BaseValidator {
	constructor(otherField) {
		super();
		this.otherField = otherField;
	}

	name(model) {
		let fieldDef = model.fieldDefs.find((x) => x.key == this.otherField);
		if (fieldDef) {
			return "Must be less than " + fieldDef.title;
		}
		return "Must be less than " + this.otherField;
	}

	logic(x, model, data) {
		if (x != null && !isNaN(x)) {
			let otherValue = data[this.otherField];
			if (otherValue != null && !isNaN(otherValue)) {
				return Number(x) < Number(otherValue);
			}
		}

		return true;
	}

	message(model) {
		let fieldDef = model.fieldDefs.find((x) => x.key == this.otherField);
		if (fieldDef) {
			return "Must be less than " + fieldDef.title;
		}
		return "Must be less than " + this.otherField;
	}
}